const GameEndRefreshVector = (props) => {
  return (
    <svg
      width={17}
      height={16}
      fill="current"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0_2_2)">
        <path
          d="M14.15 2.35A7.958 7.958 0 008.5 0C4.08 0 .51 3.58.51 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08a5.99 5.99 0 01-5.65 4c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L9.5 7h7V0l-2.35 2.35z"
          fill="current"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_2_2">
          <path fill="current" d="M0 0h17v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GameEndRefreshVector;
